/**
 * V14.3 — Light-mode-only.
 *
 * Dark mode was removed per user request because the dormant `dark:*`
 * Tailwind utilities scattered across the app rendered inconsistently
 * (sidebar/content card contrast issues). This module is now a no-op
 * shim that:
 *   1. Forcibly removes the `dark` class from <html> on every call
 *      (cleans up any state from V14.0/V14.1 users who had picked dark).
 *   2. Clears the stored theme preference keys so old localStorage
 *      values don't keep re-applying dark on next bootstrap.
 *   3. Keeps `applyTheme` / `getStoredThemePref` exports as no-ops so
 *      any lingering imports don't crash the build.
 */

const STORAGE_KEY = 'ss_theme_pref';
const LEGACY_DARK_KEY = 'ss_dark_mode';

function forceLight() {
  try {
    document.documentElement.classList.remove('dark');
  } catch {
    // SSR / no-DOM — nothing to do
  }
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(LEGACY_DARK_KEY);
  } catch {
    // localStorage may be blocked (private mode etc.)
  }
}

export function getStoredThemePref() {
  return 'light';
}

export function applyTheme() {
  forceLight();
}

export function bootstrapTheme() {
  forceLight();
}
